if (!window.hasOwnProperty('appModules')) {
    window.appModules = {};
}

window.appModules.Constructor = function () {
    var el = this;
    var initialized = false;
    var INTERIOR_GROUP_ID = 5;

    el.isCheckingOnloadStatus = false;

    el._parent = this;
    el.MM_IN_PIXELS = 2.54 / (300 / 10);
    el.WORKAREA_WIDTH = 800;
    
    el.productGroupId = INTERIOR_GROUP_ID;

    el.svgRoot = false;
    el.selectType = '';
    el.selectId = 0;
    el.selectWorkareaId = 1;
    el.currentProduct = {};
    el.workData = {};
    el.valve = 0;
    el.enforceLogin = 0;
    el.showFastOrder = 0;
    el.homeLink = '/';
    el.user = {};

    el.isTransforming = false;

    function initModules() {
        window.Workarea.prototype = el;
        window.UpImages.prototype = el;
        window.Select.prototype = el;
        window.Calculator.prototype = el;
        window.ImageBackground.prototype = el;
        window.ImageCell.prototype = el;
        window.Project.prototype = el;
        window.Layer.prototype = el;
        window.Hotkeys.prototype = el;
        window.TransformView.prototype = el;
        window.History.prototype = el;
        window.Format.prototype = el;
        window.Dialog.prototype = el;
        window.Cell.prototype = el;
        window.BorderCell.prototype = el;
        window.Grid.prototype = el;
        window.Text.prototype = el;

        el.workarea = new window.Workarea();
        el.upImages = new window.UpImages();
        el.calculator = new window.Calculator();
        el.selection = new window.Select();
        el.background = new window.ImageBackground();
        el.image = new window.ImageCell();
        el.project = new window.Project();
        el.layer = new window.Layer();
        el.hotkeys = new window.Hotkeys();
        el.notice = new window.Notice();
        el.transform = new window.TransformView();
        el.history = new window.History();
        el.format = new window.Format();
        el.dialog2 = new window.Dialog();
        el.cell = new window.Cell();
        el.borderCell = new window.BorderCell();
        el.grid = new window.Grid();
        el.text = new window.Text();

        window.Upload.prototype = el;
        el.upload = new Upload({
            upload_url: '/api/interior/photos/upload/' + window.bookSid,
            mime_types: 'image/jpeg',
            maxSize: 200000000, // 200MB
            fileUploaded: function (file) {
                el.upImages.add(file);
            },
            uploadComplete: function () {
                el.showContainer('main-page');
                el.upImages.render();
                el.workarea.render();
            }
        });

        initialized = true;
    }

    function initEvents() {
        $('body')
                .on('mousemove touchmove', el.continueOperationsElement)
                .on('mouseup touchend', el.endOperationsElement);

        $(document).on('click', '.dropdown-menu li a', function () {
            $(this).parents('.btn-group').find('.dropdown-toggle').html($(this).text() + ' <span class="caret"></span>');
        });

        $(document).on('click', '.js-step-calculator', function () {
            if (!el.upImages.isUsedImages()) {
                el.dialog.show('message', {message: 'Необходимо загрузить изображение для оформления заказа'});
                return;
            }
            
            $('.page-step').addClass('hide');
            $('#page-step-calculator').removeClass('hide');
        });

        $(document).on('click', '.js-step-constructor', function () {
            $('.page-step').addClass('hide');
            $('#page-step-constructor').removeClass('hide');
        });

        $(document).on('click', '.js-step-shopcart', function () {
            if (!el.upImages.isUsedImages()) {
                el.dialog.show('message', {message: 'Необходимо загрузить изображение для оформления заказа'});
                return;
            }
            el.text.removeDefaultTexts();

            if (el.showFastOrder) {
                el.dialog.show('fast_order', {user: el.user, homeLink: el.homeLink});
            } else {
                el.shopcart();
            }
        });
        
        $(window).resize(function () {
            if (!$('#page-step-constructor').hasClass('hide')) {
                el.upImages.render();
                el.workarea.render();
            }
        });
    }

    el.init = function () {
        el.loader.show('Загрузка данных конструктора фотокниг ...');
      
        console.log(window.productTitle)
        $.getJSON('/api/interior/constructor/get/' + window.productTitle)
                .done(function (response) {
                    initModules();
                    initEvents();

                    el.format.items = response.formats;
                    el.grid.items = response.grids;
                    el.grid.cells = response.grid_cells;
                    el.workarea.workareas = response.workareas;
                    el.workarea.workarea_formats = response.workarea_formats;
                    el.calculator.price = response.price;
                    el.calculator.priceGroupId = response.price_group_id;
                    el.calculator.propertyTypes = response.property_types;
                    el.calculator.properties = response.properties;
                    el.calculator.currency = response.currency;
                    el.currentProduct = response.product;
                    el.text.fonts = response.fonts;
                    el.enforceLogin = parseInt(response.enforce_login);
                    el.showFastOrder = parseInt(response.show_fast_order);
                    el.user = response.user;
                    el.homeLink = response.home_link;
                    el.projectsPath = response.projects_path;


                    window.bookConstructor = el; //compabality
                    el.project.load(window.bookSid);
                    $('[data-toggle="popover"]').popover({html: true});
                    el.loader.hide();

                    if (Object.keys(el.workarea.workareas).length !== 0) {
                        $('.js-workareas-show').removeClass('hide');
                    } else {
                        $('.js-text-add').removeClass('hide');
                        $('.js-grids-show').removeClass('hide');
                        $('.js-cell-add').removeClass('hide');
                        $('.formats').removeClass('hide');
                        $('.js-change-orientation').removeClass('hide');
                    }
                })
                .fail(function () {
                    el.loader.hide();
                    alert('Ошибка загрузки данных конструктора фотокниг. \nПерезагрузите страницу или зайдите позже');
                });
    };

    el.generateShopCartData = function() {
        var data = {
            product_group_id: 5,
            name: (el.currentProduct.company.name ? el.currentProduct.company.name : el.currentProduct.default.name) + ' ' + el.format.current.name,
            items: {
                project_id: el.project.current.id
            }
        };

        data.items = JSON.stringify(data.items);
        return data;
    };

    el.shopcart = function () {
        el.project.save(function () {
            var data = el.generateShopCartData();
            
            el.request.post('/shopcart/items', data, function (response) {
                if (response.hasOwnProperty('error')) {
                    alert(response.error.description);
                    return false;
                }

                el.isCheckingOnloadStatus = false;

                window.location.href = '/shopcart';
            }, 'json');
        });

    };

    el.continueOperationsElement = function (event) {
        if (initialized && el.isTransforming) {
            el.dialog2.move(event);
            el.background.move(event);
            el.image.move(event);
            el.cell.move(event);
            el.cell.resize(event);
            el.cell.rotate(event);
            el.text.move(event);
            el.text.rotate(event);
        }
    };

    el.endOperationsElement = function () {
        if (initialized && el.isTransforming) {
            el.isTransforming = false;

            el.dialog2.endMove();
            el.background.endMove();
            el.image.endMove();
            el.cell.endMove();
            el.cell.endResize();
            el.cell.endRotate();
            el.text.endMove();
            el.text.endRotate();
        }
    };

    el.checkUnload = function (e) {
        if (el.isCheckingOnloadStatus) {
            e = e || window.event;
            
            el.project.save();

            e.cancelBubble = true;
            e.returnValue = 'При выходе Ваш проект может не сохранится.';

            if (e.stopPropagation) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };

    el.showContainer = function (name) {
        $('.page').addClass('invisible');
        $('#' + name).removeClass('invisible');

        if (name === 'upload-page') {
            el.upload.computer.init();
            $('.upload-hide').removeClass('hide');
        }
        
        if (name === 'main-page') {
            el.workarea.render();
        }
    };
    
    el.init();
    window.onbeforeunload = el.checkUnload;
};

if (window.hasOwnProperty('app')) {
    app.initModule('constructor', window.appModules.Constructor);
}